<template>
  <div class="tarjetas-resumenes">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :noResumen="noResumen"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :banco="banco"
          :tarjetaMarca="tarjetaMarca"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card :header="titulo">
            <b-table hover
                responsive="sm" 
                :class="{
                  'registro': true,
                  'no-resumen': noResumen
                }"
                :busy="tableBusy"
                :items="tarjetasResumenes" 
                :fields="fields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(tarjeta)="data">
                {{ data.item.tarjetaMarca }} {{ data.item.banco }}
              </template>
              <template v-slot:cell(fechaCierre)="data">
                {{ data.item.fechaCierre | fecha }}
              </template>
              <template v-slot:cell(fechaVencimiento)="data">
                {{ data.item.fechaVencimiento | fecha }}
              </template>
              <template v-slot:cell(cupones)="data">
                {{ data.item.cupones | numero(0, true) }}
              </template>
              <template v-slot:cell(importePesos)="data">
                {{ data.item.importePesos | moneda }}
              </template>
              <template v-slot:cell(importeDolares)="data">
                {{ data.item.importeDolares | moneda('USD') }}
              </template>
              <template v-slot:cell(importeCierrePesos)="data">
                <template v-if="data.item.cerrado">
                  {{ data.item.importeCierrePesos | moneda }}
                </template>
              </template>
              <template v-slot:cell(saldoAnteriorPesos)="data">
                {{ data.item.saldoAnteriorPesos | moneda }}
              </template>
              <template v-slot:cell(importeCierreDolares)="data">
                <template v-if="data.item.cerrado">
                  {{ data.item.importeCierreDolares | moneda('USD') }}
                </template>
              </template>
              <template v-slot:cell(importePagadoPesos)="data">
                <template v-if="data.item.pagado">
                  {{ data.item.importePagadoPesos | moneda }}
                </template>
              </template>
              <template v-slot:cell(importePagadoDolares)="data">
                <template v-if="data.item.pagado">
                  {{ data.item.importePagadoDolares | moneda('USD') }}
                </template>
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click.stop="consultar(data.item)">
                    <i class="fa fa-info"></i>{{ noResumen? 'Consultar Cupones' : 'Consultar Resumen' }}</b-dropdown-item>

                  <b-dropdown-item
                      v-if="!noResumen & !data.item.cerrado"
                      @click.stop="cerrarResumen(data.item)">
                    <i class="fa fa-lock"></i>Cerrar Resumen</b-dropdown-item>

                  <b-dropdown-item
                      v-if="!noResumen & data.item.cerrado & !data.item.pagado"
                      @click.stop="borrarCierreResumen(data.item)">
                    <i class="fa fa-remove"></i>Borrar Cierre</b-dropdown-item>

                  <b-dropdown-item
                      v-if="!noResumen & data.item.cerrado & !data.item.saldoPendiente"
                      @click.stop="saldoPendiente(data.item)">
                    <i class="fa fa-usd"></i>Saldo Pendiente</b-dropdown-item>
                    
                  <b-dropdown-item
                      v-if="!noResumen & data.item.cerrado & !data.item.saldoPendiente"
                      @click.stop="pagarResumen(data.item)">
                    <i class="fa fa-usd"></i>Pagar Resumen</b-dropdown-item>

                  <b-dropdown-item
                      v-if="!noResumen & data.item.cerrado"
                      @click.stop="consultarPagos(data.item)">
                    <i class="fa fa-list"></i>Consultar Pagos</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <nav v-if="!noResumen">
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="cierreModal"
        title="Cierre del Resumen"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-cierre
        :tarjetaResumenId="tarjetaResumenId"
        @close="closeCierre">
      </app-cierre>  
    </b-modal>

    <b-modal ref="cierreModal"
        title="Cierre del Resumen"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-cierre
        :tarjetaResumenId="tarjetaResumenId"
        @close="closeCierre">
      </app-cierre>  
    </b-modal>

    <b-modal ref="saldoModal"
        title="Saldo Pendiente"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-saldo
        :tarjetaResumenId="tarjetaResumenId"
        @close="closeSaldoPendiente">
      </app-saldo>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Cierre from  './Cierre.vue';
import Saldo from  './Saldo.vue';
import Filtro from  './vencimientosFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetasResumenesVencimientos/getField',
  mutationType: 'tarjetasResumenesVencimientos/updateField',
});

export default {
  name:'TarjetasResumenesVencimientos',
  components: {
    appCierre: Cierre,
    appSaldo: Saldo,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  props: {
    noResumen: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentRouteName: '',
      fields: [],
      tableBusy: false,

      tarjetaResumenId: 0,
    }
  },
  computed: {
    ...mapFields([
      'tarjetasResumenes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'banco',
      'tarjetaMarca'
    ]),
    titulo() {
      if ((/true/i).test(this.noResumen)) {
        return "Listado de Cupones Pendientes";
      }

      return "Listado de Resúmenes";
    },
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
  },
  created() {
    this.currentRouteName = this.$route.name;

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.banco = filtro.banco;
      this.tarjetaMarca = filtro.tarjetaMarca;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getFields() {
      this.fields = [
        // {
        //   key: 'banco',
        //   label: 'Banco',
        // },
        // {
        //   key: 'tarjetaMarca',
        //   label: 'Tarjeta',
        // },
        {
          key: 'tarjeta',
          label: 'Tarjeta',
        },
        {
          key: 'numeroCuenta',
          label: 'Nro.Cuenta',
        }
      ]

      if ((/true/i).test(this.noResumen) == false) {
        this.fields.push(
          {
            key: 'fechaCierre',
            label: 'Cierre',
          },
          {
            key: 'fechaVencimiento',
            label: 'Vencimiento',
          }
        )
      }

      if ((/true/i).test(this.noResumen)) {
        this.fields.push(
          {
            key: 'cupones',
            class: 'text-right'
          },
          {
            key: 'importePesos',
            label: 'Total - $',
            class: 'text-right'
          },
          {
            key: 'importeDolares',
            label: 'Total - USD',
            class: 'text-right'
          },
          { 
            key: 'opciones',
            label: '',
            class:'text-center'
          }
        )
      } else {
        this.fields.push(
          {
            key: 'cupones',
            class: 'text-right'
          },
          {
            key: 'importePesos',
            label: 'Total - $',
            class: 'text-right'
          },
          {
            key: 'importeCierrePesos',
            label: 'Cierre',
            class: 'text-right'
          },
          {
            key: 'saldoAnteriorPesos',
            label: 'Saldo Ant.',
            class: 'text-right'
          },
          {
            key: 'importePagadoPesos',
            label: 'Pagos',
            class: 'text-right'
          },
          {
            key: 'importeDolares',
            label: 'Total - USD',
            class: 'text-right'
          },
          {
            key: 'importeCierreDolares',
            label: 'Cierre',
            class: 'text-right'
          },
          {
            key: 'importePagadoDolares',
            label: 'Pagos',
            class: 'text-right'
          },
          { 
            key: 'opciones',
            label: '',
            class:'text-center'
          }
        )
      }
    },
    getItems() {
      this.tableBusy = true;
      this.getFields();
      let dispatch = 'tarjetasResumenesVencimientos/getTarjetasResumenes';
      if ((/true/i).test(this.noResumen)) {
        dispatch = 'tarjetasResumenesVencimientos/getTarjetasNoResumenes';
      }

      this.$store.dispatch(dispatch)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      if ((/true/i).test(this.noResumen)) {
        this.$router.push({ name: 'TarjetaResumenDataNoResumen', 
                            params: { tarjetaId: item.tarjetaId }});      
      } else {
        this.$router.push({ name: 'TarjetaResumenData', 
                            params: { id: item.id }});      
      }
    },
    cerrarResumen (item) {
      if (!(/true/i).test(this.noResumen)) {
        this.tarjetaResumenId = item.id;
        this.$refs.cierreModal.show();
      }
    },
    closeCierre(cierreRegistrado) {
      this.$refs.cierreModal.hide();
      if (cierreRegistrado) {
        this.getItems();
      }
    },
    borrarCierreResumen(item) {
      this.showModalConfirm('¿Desea eliminar el cierre del resumen seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar(tarjetaResumenId) {
      this.showSpinner();
      this.$store.dispatch('tarjetaResumenCierre/delete', tarjetaResumenId)
        .then(() => this.showModalMsj('El cierre del resumen se eliminó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    pagarResumen (item) {
      if (!(/true/i).test(this.noResumen)) {
        this.$router.push({ name: 'TarjetaResumenPago', 
                            params: { tarjetaResumenId: item.id }});      
      }
    },
    consultarPagos (item) {
      if (!(/true/i).test(this.noResumen)) {
        this.$router.push({ name: 'TarjetaResumenPagos', 
                            params: { tarjetaResumenId: item.id }});      
      }
    },
    saldoPendiente (item) {
      if (!(/true/i).test(this.noResumen)) {
        this.tarjetaResumenId = item.id;
        this.$refs.saldoModal.show();
      }
    },
    closeSaldoPendiente(saldoPendienteRegistrado) {
      this.$refs.saldoModal.hide();
      if (saldoPendienteRegistrado) {
        this.getItems();
      }
    },

  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },
    '$route'() {
      if (this.$route.name.trim() != this.currentRouteName) {
        this.getItems();
      }
    }    
  }    
}
</script>

<style>
  .tarjetas-resumenes .registro table td[aria-colindex="1"] {
    width: 12%;
  }
  /* .tarjetas-resumenes .registro table td[aria-colindex="2"] {
    width: 10%;
  } */
  .tarjetas-resumenes .registro table td[aria-colindex="2"] {
    width: calc(7% - 30px);
  }
  .tarjetas-resumenes .registro table td[aria-colindex="3"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="4"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="5"] {
    width: 6%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="6"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="7"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="8"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="9"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="10"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="11"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="12"] {
    width: 8%;
  }
  .tarjetas-resumenes .registro table td[aria-colindex="13"] {
    width: 30px;
  }

  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="1"] {
    width: 30%;
  }
  /* .tarjetas-resumenes .registro.no-resumenes table td[aria-colindex="2"] {
    width: 15%;
  } */
  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="2"] {
    width: calc(30% - 30px);
  }
  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="3"] {
    width: 10%;
  }
  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="4"] {
    width: 15%;
  }
  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="5"] {
    width: 15%;
  }
  .tarjetas-resumenes .registro.no-resumen table td[aria-colindex="6"] {
    width: 30px;
  }  
</style>
